import { getIsProdDomain } from "@/api";

const isProdDomain = getIsProdDomain();

// 进程列表
export const PROGRESS_LIST = [
  {
    id: "1",
    title: "候选报名期",
    desc: "参评人提交参评资料",
    startTime: "2024/11/11",
    endTime: "2024/12/01",
    routerPathPC: "selectionPc",
    routerPathH5: "selection"
  },
  {
    id: "2",
    title: "网络投票期",
    desc: "为候选人/团队投票",
    startTime: "2024/12/02",
    endTime: "2024/12/15",
    routerPathPC: "votePc",
    routerPathH5: "vote"
  },
  {
    id: "3",
    title: "综合评审期",
    desc: "评审及综合评分",
    startTime: "2024/12/16",
    endTime: "2024/12/20",
    routerPathPC: "evaluationPc",
    routerPathH5: "evaluation"
  },
  {
    id: "4",
    title: "入围通知",
    desc: "发送入围通知",
    startTime: "2024/12/23",
    endTime: "2024/12/27",
    routerPathPC: "evaluationPc",
    routerPathH5: "evaluation"
  },
  {
    id: "5",
    title: "颁奖典礼",
    desc: "公布最终获奖名单",
    startTime: "2025/01/07",
    endTime: "",
    routerPathPC: "outcomePc",
    routerPathH5: "outcome"
  }
];

// 评选介绍
export const INTRO_LIST = [
  {
    id: "1",
    content:
      "“中国卓越 IR 年度评选”是由 RoadshowChina 路演中及其旗下子品牌卓越IR发起，是国内唯一专注聚焦上市公司投资者关系一线从业者以及投资者关系卓越项目的年度奖项，以表彰优秀的上市公司IR团队及个人为推动行业变革与发展作出的卓越贡献。"
  }
];

// 评选亮点
export const HIGHLIGHT_LIST = [
  {
    id: "1",
    className: "ir",
    bgClass: "ir-bg",
    titleClass: "ir-title",
    desc:
      "站在行业与市场变革的转折点，如同身处拂晓，优秀的团队与个人是带领行业向前眺望的先锋，你的成绩值得被致敬与学习。"
  },
  {
    id: "2",
    className: "focus",
    bgClass: "focus-bg",
    titleClass: "focus-title",
    desc:
      "我们紧跟IR行业研究的最新趋势，为了表彰与推动行业的卓越发展，我们不断发掘并创新奖项，因为我们深信，你的杰出成果值得被嘉奖。"
  },
  {
    id: "3",
    className: "person",
    bgClass: "person-bg",
    titleClass: "person-title",
    desc:
      "在这个走在时代前沿，并蓬勃发展的行业中，从不缺少后起之秀，我们全新推出“最佳年度新锐公司”、“最佳ESG新秀奖”，为嘉奖那些展示潜力并迅速取得进展的公司。"
  }
];

// 团队奖项
export const AWARD_TEAM_LIST = [
  {
    id: "1",
    title: "最佳路演中国奖",
    titleImg: require("@/assets/selection/mobile/selection/best-roadshow-china-award.png"),
    titleClass: "communication",
    descList: [
      {
        id: "11",
        content:
          "我们敬佩出海先行者探索的勇气与智慧。伴随经济全球化进程的加速推进和“一带一路”建设带来的新机遇，2024年以来中国企业出海步伐进一步加快，与此同时中国市场对海外资本持续散发吸引力，国际投资者愈发重视中国市场。如何面向世界讲述“中国故事”，讲好“中国故事”，亦成为上市公司在新形势下开展投关工作的全新挑战。",
        strong:
          "中国卓越IR”最佳路演中国奖“旨在嘉奖2024年度已在全球资本市场范围形成一定影响力，在跨境投资者沟通及交流工作上取得卓越成效并在全球范围内构建坚实资本市场品牌的上市公司。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "team"
  },
  {
    id: "2",
    title: "最佳价值创造奖",
    titleImg: require("@/assets/selection/mobile/selection/best-value-creation-award.png"),
    titleClass: "esg",
    descList: [
      {
        id: "21",
        content:
          "市值管理这一概念自提出以来经历了20余年的概念萌芽与理论探索，2024年以来A股资本市场的首部市值管理指引标志着市值管理元年的正式开启，明确了上市公司提高自身质量，运用各类方式推动上市公司投资价值充分反映上市公司质量，进而提升投资价值，增强投资者回报的市值管理路径。",
        strong:
          "中国卓越IR“最佳价值创造”旨在嘉奖于2024年度在市值管理课题上深入研究，并在投资价值、上市公司质量、投资者回报等关键领域做出重大举措，赢得资本市场广泛认可和支持的上市公司。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "team"
  },
  {
    id: "3",
    title: "最佳资本市场沟通奖",
    titleImg: require("@/assets/selection/mobile/selection/award-team-communication.png"),
    titleClass: "info",
    descList: [
      {
        id: "31",
        content:
          "有效沟通将增强公司价值。IR作为上市公司与投资者之间的纽带，需要与资本市场保持高频交流，一方面将公司的情况客观、全面、及时地告知投资人，赢得投资人的信任和认同，从而实现公司价值被合理估值；另一方面也需要对内反馈市场需求与建议，促进企业业务调整和核心指标的提升。",
        strong:
          "中国卓越IR“最佳资本市场沟通奖”旨在嘉奖在2024年度主动、积极、创新的通过适宜方式与资本市场各参与方保持良好、密切、通畅的沟通，且在沟通质量、沟通频次及沟通效果方面均取得良好成果的IR团队及上市公司。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "team"
  },
  {
    id: "4",
    title: "最佳ESG奖",
    titleImg: require("@/assets/selection/mobile/selection/award-team-esg.png"),
    titleClass: "info",
    descList: [
      {
        id: "41",
        content:
          "ESG是Environmental（环境）、Social（社会）和Governance（治理）的缩写，是一种关注企业环境、社会、治理绩效而非财务绩效的投资理念和企业评价标准。作为ESG评级体系中的被评级方，上市公司在ESG生态圈中扮演着非常重要的角色。随着ESG披露要求的不断提高和细化、投资机构在决策过程中对ESG考量的持续加码，上市公司对ESG的重视无论是在短期股价还是长期价值上都将对企业有着积极而显著的影响，某种程度上ESG是一种价值观。",
        strong:
          "中国卓越IR“最佳ESG奖”旨在嘉奖2024年度在上市公司ESG体系建设、ESG信息披露、ESG沟通实践中有卓越表现、并获得利益相关方广泛认可的上市公司。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "team"
  },
  {
    id: "5",
    title: "最佳ESG新秀奖",
    titleImg: require("@/assets/selection/mobile/selection/award-team-esg-people.png"),
    titleClass: "investor-relation",
    descList: [
      {
        id: "51",
        content:
          "ESG理念是企业实现可持续发展，实现多方共赢，共创长期价值的重要指引。作为一种综合关注环境、社会和治理绩效的新兴企业评价体系，愈来愈多的上市公司逐步重视可持续发展理念，并积极在公司管治、企业实践、技术融合等多个领域做出有益探索。",
        strong:
          "中国卓越IR“最佳ESG新秀奖”旨在表彰已高度认可并重视ESG理念对于上市公司长期可持续发展的重要性，且最近三个年度已将ESG发展战略融入公司治理架构及未来发展理念，具备ESG工作高增长潜力的相关表现，并于2024年内在ESG体系建设、ESG信息披露、ESG沟通实践有突出表现的上市公司。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "team"
  },
  {
    id: "6",
    title: "最佳信披奖",
    titleImg: require("@/assets/selection/mobile/selection/award-team-info.png"),
    titleClass: "practice",
    descList: [
      {
        id: "61",
        content:
          "公平、公正、公开是市场发展的基石，合规高效的信息披露工作是一家上市公司赢得投资者信任和尊重的前提。",
        strong:
          "中国卓越IR最佳信披奖旨在嘉奖在2024年度信息披露工作中切实践行对每位投资者公平、公正、公开的工作原则，能够真实、准确、完整、及时地处理信息披露工作，同时在呈现披露内容方面足够简明清晰、通俗易懂，整体披露质量在上市公司群体中能起到示范效应的信披团队及上市公司。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "team"
  },
  {
    id: "7",
    title: "最佳数字化投资者关系奖",
    titleImg: require("@/assets/selection/mobile/selection/award-team-investor-relation.png"),
    titleClass: "shareholder",
    descList: [
      {
        id: "71",
        content:
          "中国证监会发布实施的《上市公司投资者关系管理工作指引》中明确鼓励上市公司加强建设网络沟通、采用新媒体平台开展投资者关系活动、建立健全投资者关系管理档案和数据库。对于上市公司而言，通过数字化传播手段与科技赋能投资者高效获取信息，助力上市公司不断丰富沟通渠道、优化信息展示形式，以多元手段确保与投资者的交流更通畅已成大势。",
        strong:
          "中国卓越IR“最佳数字化投资者关系奖”旨在嘉奖2024年度在投资者关系管理工作中开创性将数字化应用于IR工作场景并取得成效的IR团队及上市公司。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    // className: "team"
    className: "team-rect"
  },
  {
    id: "8",
    title: "最佳投资者关系项目",
    titleImg: require("@/assets/selection/mobile/selection/award-team-investor-project.png"),
    titleClass: "investor-project",
    descList: [
      {
        id: "81",
        content:
          "投资者关系工作是一项全面、系统而长期的工作 。无论是顶层的IR战略规划、强势资本品牌设计，中观层面的再融资、收并购、引入战投等资本项目的操盘，还是实践层面的IR年度投资者沟通计划、资本市场品牌传播、危机公关等执行性项目的推进都是对IR团队综合素质的考验。",
        strong:
          "中国卓越IR“最佳投资者关系项目”旨在嘉奖于2024年度上市公司投资者关系工作中，经由IR团队通力协作，在业绩说明会、投资者开放日等诸多投资者交流场景中涌现出的体系化、创新性、具备行业标杆和最佳实践意义的投资者关系项目。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "team"
  },
  {
    id: "9",
    title: "最佳年度新锐公司",
    titleImg: require("@/assets/selection/mobile/selection/award-team-corporation.png"),
    titleClass: "investor-corporation",
    descList: [
      {
        id: "91",
        content:
          "向新而生，锐意进取。“新锐”一词意味着在短时间内取得卓越成就并表现出非凡的潜力。对于初登陆资本市场的企业，即将在产融结合发展的全新赛道上拾级而上，往往机遇与挑战并存。“最佳年度新锐公司”不仅是因为短期内取得卓越的发展成果，更是因为它们背后所体现的团队合作精神和不懈努力而获得奖项。",
        strong:
          "中国卓越IR“最佳年度新锐公司”奖项将授予在资本市场上取得突出成就并广受瞩目的新上市公司。该奖项旨在表彰那些成功登陆资本市场，迅速获得广泛利益相关方认可并展现高增长潜力的上市公司。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "team"
  }
];

// 个人奖项
export const AWARD_PERSON_LIST = [
  {
    id: "1",
    title: "最佳领袖奖",
    descList: [
      {
        id: "11",
        content:
          "旨在嘉奖在2024年度IR工作中追求卓越的董秘、CFO及以上级别的Leader。他们运筹帷幄，决胜千里，无论在个人魅力还是团队管理、战略创新、资本运作等方面都具有突出表现；他们对行业有深刻的洞察，把推动IR领域向前发展当作自身的责任；他们培养新人，也身体力行地影响着万千IR从业者。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "person"
  },
  {
    id: "2",
    title: "最佳总监奖",
    descList: [
      {
        id: "21",
        content:
          "中国卓越IR最佳总监奖旨在嘉奖在2024年度IR工作中追求卓越、具有领导力的总监、经理及以上级别的IR工作者。他们争当领头人，带领团队在投资者关系事务中披荆斩棘；他们事事追求卓越，将维护良好股东关系作为自己工作的座右铭，将公司价值用最高效的方式传递给市场；他们的专业能力、沟通能力、协同能力让人叹服。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "person2"
  }
];

// 年度榜单-35UNDER35
export const AWARD_ANNUAL_35 = {
  id: "1",
  title: "35 UNDER 35",
  descList: [
    {
      id: "11",
      content:
        "据IR白皮书调研数据显示，中国上市公司投资者关系从业群体正在历经史上最大规模的代际交替：00后崭露头角，95后登上舞台，85后成为IR群体的中坚力量。2024年中国卓越IR全新推出“35 UNDER 35”榜单，颁发给35位35岁以下卓越的IR从业者，他们是这个行业真正年富力强的推动者，将创造出IR行业更多可能性。"
    }
  ],
  remarkTitle: "参评条件:",
  remarkList: [
    {
      id: "11",
      content: "1.1989年及以后出生；"
    },
    {
      id: "12",
      content: "2.从事投资者关系工作不低于3年，并取得重要成果。"
    }
  ],
  url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
  className: "annual-35"
};

// 年度榜单-上市公司路演热度榜
export const AWARD_ANNUAL_RANK = {
  title: "上市公司路演热度榜",
  descList: [
    {
      id: "11",
      content:
        "上市公司路演热度(CHP)以上市公司路演大数据及投资机构用户投票为基础，由五个维度的热度得分组成，分别为“关注热度”、“参会热度”、“研究热度”、“覆盖热度”、“投票热度”，以客观数据+主观票选，实时反应上市公司在市场上的关注度，仅供专业投资者参考，不作为投资建议。"
    }
  ],
  remarkTitle: "",
  remarkList: [
    {
      id: "11",
      content:
        "注：热度总分按照每个维度所占权重进行总分的计算，然后对热度总分进行榜单排名。该热度榜单将以数止2022年11月30日24:00的路演中平台数据自动生成。"
    }
  ],
  urlCompany: `https://${
    isProdDomain ? "www" : "www-sit"
  }.roadshowchina.cn/wap/ranking/index.html`,
  urlIr: `https://${
    isProdDomain ? "www" : "www-sit"
  }.roadshowchina.cn/wap/ranking/index.html?rank_date_time_ir=0`,
  className: "annual-rank",
  introTitleType: "img",
  introTitleImg: require("@/assets/selection/mobile/selection/award-annual-rank-title.png"),
  introTitleClass: "annual-rank-intro-title"
};

// 特别奖项
export const AWARD_SPECIAL_LIST = [
  {
    id: "1",
    title: "人气女神奖",
    descList: [
      {
        id: "11",
        content: "专业与颜值并重，最受市场欢迎女神就是你!"
      },
      {
        id: "12",
        content: "该奖项由网络投票数最高的女性IR工作者获得。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "special special-goddess"
  },
  {
    id: "2",
    title: "人气男神奖",
    descList: [
      {
        id: "21",
        content: "能力与人气齐飞，最受市场欢迎男神就是你!"
      },
      {
        id: "22",
        content: "该奖项由网络投票数最高的男性IR工作者获得。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "special special-malegod"
  },
  {
    id: "3",
    title: "最佳合作伙伴",
    descList: [
      {
        id: "31",
        content:
          "2024年度，众多资本市场服务商中的佼佼者在产业协同、战略合作、研究支持等板块持续携手路演中与卓越IR为上市公司投资者关系工作提供深度支持，为IR 工作者成长赋能。本次颁奖盛典，我们将颁出“最佳合作伙伴”奖项，以资感谢。"
      }
    ],
    url: "https://www.wjx.cn/vm/PMNjcC0.aspx?udsid=841573",
    className: "special-partner"
  }
];

// 参评指引
export const GUIDANCE_LIST = [
  {
    id: "1",
    content:
      "方式一：点击网页底部“参评指引”下载文档，在文档内通过链接填写报名表及白皮书问卷完成报名"
  },
  {
    id: "2",
    content:
      "方式二：点击上述奖项旁“立刻参选”按钮，填写报名表及白皮书问卷完成报名"
  }
];
export const GUIDANCE_PC_LIST = [
  {
    id: "1",
    content:
      "方式一：点击网页右侧“参评指引”下载文档，在文档内通过链接填写报名表及白皮书问卷完成报名"
  },
  {
    id: "2",
    content:
      "方式二：点击上述奖项旁“立刻参选”按钮，填写报名表及白皮书问卷完成报名"
  }
];

// 评分标准
export const RATING_STANDARD_LIST = [
  {
    id: "1",
    title: "团队奖项",
    type: "team",
    children: [
      {
        id: "11",
        title: "最佳路演中国奖",
        desc: "客观评分（70%）+网络投票（20%）+白皮书评分（10%）"
      },
      {
        id: "12",
        title: "最佳价值创造奖",
        desc: "客观评分（70%）+网络投票（20%）+白皮书评分（10%）"
      },
      {
        id: "13",
        title: "最佳资本市场沟通奖",
        desc: "客观评分（60%）+网络投票（30%）+白皮书评分（10%）"
      },
      {
        id: "14",
        title: "最佳ESG奖",
        desc: "客观评分（70%）+网络投票（20%）+白皮书评分（10%）"
      },
      {
        id: "15",
        title: "最佳ESG新秀奖",
        desc: "客观评分（90%）+白皮书评分（10%）"
      },

      {
        id: "16",
        title: "最佳信披奖",
        desc: "客观评分（90%）+白皮书评分（10%）"
      },
      {
        id: "17",
        title: "最佳数字化投资者关系奖",
        desc: "客观评分（30%）+网络投票（20%）+白皮书评分（50%）"
      },
      {
        id: "18",
        title: "最佳投资者关系项目",
        desc: "客观评分（70%）+网络投票（20%）+白皮书评分（10%）"
      },
      {
        id: "19",
        title: "最佳年度新锐公司",
        desc: "客观评分（90%）+白皮书评分（10%）"
      }
    ]
  },
  {
    id: "2",
    title: "个人奖项",
    type: "individual",
    children: [
      {
        id: "21",
        title: "最佳领袖奖",
        desc: "客观评分（70%）+网络投票（20%）+白皮书评分（10%）"
      },
      {
        id: "22",
        title: "最佳总监奖",
        desc: "客观评分（70%）+网络投票（20%）+白皮书评分（10%）"
      },
      {
        id: "23",
        title: "35 UNDER 35",
        desc: "客观评分（70%）+网络投票（20%）+白皮书评分（10%）"
      }
    ]
  },
  {
    id: "3",
    title: "特别奖项",
    type: "special",
    children: [
      {
        id: "31",
        title: "人气女神奖",
        desc: "网络投票（100%）"
      },
      {
        id: "32",
        title: "人气男神奖",
        desc: "网络投票（100%）"
      },
      {
        id: "33",
        title: "最佳合作伙伴",
        desc:
          "颁发给2024年度携手路演中与卓越IR为上市公司投资者关系工作提供深度支持的服务商伙伴。"
      }
    ]
  }
];

// 评分依据
export const RATING_BASIS_LIST = [
  {
    id: "6",
    title: "客观评分依据",
    type: "basis",
    children: [
      {
        id: "61",
        title: "",
        desc:
          "特别设置“创新力、执行力、影响力、服务力”四个指标对所提交的参评资料进行综合审议"
      }
    ]
  }
];

export const RATING_STANDARD_BASIS = [
  {
    id: "4",
    title: "客观评分",
    children: [
      {
        id: "41",
        title: "",
        desc:
          "本次各个奖项评分标准的权重有所差异，特别设置评选专家委员会就客观评分部分进行评审，并依据“创新力、执行力、影响力、服务力”四个指标对上市公司所提交的参评资料进行综合审议"
      }
    ]
  },
  {
    id: "5",
    title: "网络投票规则",
    children: [
      {
        id: "51",
        title: "",
        desc:
          "个人投资者每天可投3票（1票=1分），机构投资者每天可投10票（其中，实名认证基金经理、研究员、卖方分析师1票=30分，其他实名认证用户1票=5分）"
      }
    ]
  }
];

// 评分标准-备注
export const RATING_STANDARD_REMARK_LIST = [
  {
    id: "1",
    content: "提交实名认证者，身份核实认证后次日可投10票。"
  },
  {
    id: "2",
    content: "投票期间严禁任何形式的刷票行为，一经发现将取消参评资格。"
  },
  {
    id: "3",
    content:
      "参选主体一年内无违法、违规、违纪行为，无证监会及交易所等相关部门的公开处罚和批评。对于上市公司相关参选主体的参评资格，主办方有最终解释权。"
  }
];

// 参评权益
export const BENEFIT_LIST = [
  {
    id: "1",
    content:
      "获得第八届中国卓越IR峰会暨颁奖盛典席位1席，入围者可获得嘉宾席位2席。"
  },
  {
    id: "2",
    content:
      "获得《2024年度上市公司投资者关系白皮书》电子版及《卓越IR学习资料包》一份。"
  },
  {
    id: "3",
    content: "获得“中国卓越IR”人物专访机会，打造个人品牌。"
  },
  {
    id: "4",
    content: "成为“IRTalks”特邀分享嘉宾，展现个人风采。"
  }
];

// 常见问题
export const QUESTION_LIST = [
  {
    id: "1",
    question: "本次活动报名收不收费？",
    answer:
      "本次活动秉持公开公平公正原则，活动报名参选过程中不产生任何费用，如遇收费行为，请及时与主办方联系。"
  },
  {
    id: "2",
    question: "每个公司最多可以报几个奖项？",
    answer: "上市公司根据自身情况，同时最多申请3个团队奖项。"
  },
  {
    id: "3",
    question: "参与评选是否一定要填写白皮书问卷？",
    answer:
      "是否填写白皮书问卷以及白皮书问卷的填写内容将与参评奖项的评分挂钩，影响评分计算。"
  },
  {
    id: "4",
    question: "为什么我提交了资料但自己的照片没有显示在对应奖项下？",
    answer:
      "参选人提交资料后，我们将对资料进行审核、整理、上传，请耐心等候，如长时间仍未有显示，可以咨询路演中-Daisy。"
  },
  {
    id: "5",
    question: "如果发现其他参评选手刷票，我应该如何举报？",
    answer:
      "本次评选遵循客观公正原则，禁止所有参选人刷票，若检测出刷票行为，我们将剔除刷票数量，严重者取消参评资格，如您发现刷票行为，请向路演中-Daisy举报。"
  },
  {
    id: "6",
    question: "",
    answer: "更多活动问题，您可咨询路演中-Daisy：19166211846 （微信/TEL）"
  }
];

// 往届回顾
export const REVIEW_LIST = [
  {
    id: "7",
    title: "第七届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20231106/#/seventh/activityPc",
    imgs: [
      require("@/assets/selection/pc/components/past-review/7-1.png"),
      require("@/assets/selection/pc/components/past-review/7-2.png"),
      require("@/assets/selection/pc/components/past-review/7-3.png"),
      require("@/assets/selection/pc/components/past-review/7-4.png")
    ]
  },
  {
    id: "6",
    title: "第六届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20221029/#/sixth/activityPc",
    imgs: [
      require("@/assets/selection/pc/selection/six1.png"),
      require("@/assets/selection/pc/selection/six2.png"),
      require("@/assets/selection/pc/selection/six3.png"),
      require("@/assets/selection/pc/selection/six4.png")
    ]
  },
  {
    id: "5",
    title: "第五届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20211125/#/activityPc",
    imgs: [
      require("@/assets/selection/pc/selection/fifth1.png"),
      require("@/assets/selection/pc/selection/fifth2.png"),
      require("@/assets/selection/pc/selection/fifth3.png"),
      require("@/assets/selection/pc/selection/fifth4.png")
    ]
  },
  {
    id: "4",
    title: "第四届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20201116/#/activityPc",
    imgs: [
      require("@/assets/selection/pc/selection/fourth1.png"),
      require("@/assets/selection/pc/selection/fourth2.png"),
      require("@/assets/selection/pc/selection/fourth3.png"),
      require("@/assets/selection/pc/selection/fourth4.png")
    ]
  },
  {
    id: "3",
    title: "第三届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20191112/index.html",
    imgs: [
      require("@/assets/selection/pc/selection/third1.png"),
      require("@/assets/selection/pc/selection/third2.png"),
      require("@/assets/selection/pc/selection/third3.png"),
      require("@/assets/selection/pc/selection/third4.png")
    ]
  },
  {
    id: "2",
    title: "第二届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20181204/index.html",
    imgs: [
      require("@/assets/selection/pc/selection/second1.png"),
      require("@/assets/selection/pc/selection/second2.png"),
      require("@/assets/selection/pc/selection/second3.png"),
      require("@/assets/selection/pc/selection/second4.png")
    ]
  },
  {
    id: "1",
    title: "第一届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url:
      "https://www.roadshowchina.cn/public/activity/20171225/html/result.html",
    imgs: [
      require("@/assets/selection/pc/selection/first1.png"),
      require("@/assets/selection/pc/selection/first2.png"),
      require("@/assets/selection/pc/selection/first3.png"),
      require("@/assets/selection/pc/selection/first4.png")
    ]
  }
];

// 峰会专题往届回顾
export const REVIEW_SPECIAL_LIST = [
  {
    id: "7",
    title: "第七届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20221029/#/sixth/activityPc",
    imgs: [
      require("@/assets/selection/pc/components/past-review/7-1.png"),
      require("@/assets/selection/pc/components/past-review/7-2.png"),
      require("@/assets/selection/pc/components/past-review/7-3.png"),
      require("@/assets/selection/pc/components/past-review/7-4.png"),
      require("@/assets/selection/pc/components/past-review/7-5.png"),
      require("@/assets/selection/pc/components/past-review/7-6.png"),
    ]
  },
  {
    id: "6",
    title: "第六届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20221029/#/sixth/activityPc",
    imgs: [
      require("@/assets/selection/pc/components/past-review/6-1.png"),
      require("@/assets/selection/pc/components/past-review/6-2.png"),
      require("@/assets/selection/pc/components/past-review/6-3.png"),
      require("@/assets/selection/pc/components/past-review/6-4.png"),
      require("@/assets/selection/pc/components/past-review/6-5.png"),
      require("@/assets/selection/pc/components/past-review/6-6.png")
    ]
  },
  {
    id: "5",
    title: "第五届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20211125/#/activityPc",
    imgs: [
      require("@/assets/selection/pc/components/past-review/5-1.png"),
      require("@/assets/selection/pc/components/past-review/5-2.png"),
      require("@/assets/selection/pc/components/past-review/5-3.png"),
      require("@/assets/selection/pc/components/past-review/5-4.png"),
      require("@/assets/selection/pc/components/past-review/5-5.png"),
      require("@/assets/selection/pc/components/past-review/5-6.png")
    ]
  },
  {
    id: "4",
    title: "第四届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20201116/#/activityPc",
    imgs: [
      require("@/assets/selection/pc/components/past-review/4-1.jpg"),
      require("@/assets/selection/pc/components/past-review/4-2.jpg"),
      require("@/assets/selection/pc/components/past-review/4-3.jpg"),
      require("@/assets/selection/pc/components/past-review/4-4.jpg"),
      require("@/assets/selection/pc/components/past-review/4-5.jpg"),
      require("@/assets/selection/pc/components/past-review/4-6.jpg")
    ]
  },
  {
    id: "3",
    title: "第三届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20191112/index.html",
    imgs: [
      require("@/assets/selection/pc/components/past-review/3-1.jpg"),
      require("@/assets/selection/pc/components/past-review/3-2.jpg"),
      require("@/assets/selection/pc/components/past-review/3-3.jpg"),
      require("@/assets/selection/pc/components/past-review/3-4.jpg"),
      require("@/assets/selection/pc/components/past-review/3-5.jpg"),
      require("@/assets/selection/pc/components/past-review/3-6.jpg")
    ]
  },
  {
    id: "2",
    title: "第二届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url: "https://vote.roadshowchina.cn/activity/20181204/index.html",
    imgs: [
      require("@/assets/selection/pc/components/past-review/2-1.jpg"),
      require("@/assets/selection/pc/components/past-review/2-2.jpg"),
      require("@/assets/selection/pc/components/past-review/2-3.jpg"),
      require("@/assets/selection/pc/components/past-review/2-4.jpg"),
      require("@/assets/selection/pc/components/past-review/2-5.jpg"),
      require("@/assets/selection/pc/components/past-review/2-6.jpg")
    ]
  },
  {
    id: "1",
    title: "第一届",
    title2: "中国卓越IR评选",
    title3: "暨颁奖盛典",
    url:
      "https://www.roadshowchina.cn/public/activity/20171225/html/result.html",
    imgs: [
      require("@/assets/selection/pc/components/past-review/1-1.jpg"),
      require("@/assets/selection/pc/components/past-review/1-2.jpg"),
      require("@/assets/selection/pc/components/past-review/1-3.jpg"),
      require("@/assets/selection/pc/components/past-review/1-4.jpg"),
      require("@/assets/selection/pc/components/past-review/1-5.jpg"),
      require("@/assets/selection/pc/components/past-review/1-6.jpg")
    ]
  }
];

// 侧边导航栏
export const SIDEBAR_NAV_LIST = [
  {
    id: "1",
    title: "活动进程",
    targetSelector: ".selection-pc__top",
    targetSelectorM: ".selection-m__top"
  },
  {
    id: "2",
    title: "评选介绍",
    targetSelector: ".selection-pc__intro",
    targetSelectorM: ".selection-m__intro"
  },
  // {
  //   id: "3",
  //   title: "评选亮点",
  //   targetSelector: ".selection-pc__highlight",
  //   targetSelectorM: ".selection-m__highlight"
  // },
  {
    id: "4",
    title: "奖项设置",
    targetSelector: ".selection-pc__award",
    targetSelectorM: ".selection-m__award",
    children: [
      {
        id: "41",
        title: "团队奖项",
        targetSelector: ".selection-pc__award--content.team",
        targetSelectorM: ".selection-m__award--content.team"
      },
      {
        id: "42",
        title: "个人奖项",
        targetSelector: ".selection-pc__award--content.person",
        targetSelectorM: ".selection-m__award--content.person"
      },
      {
        id: "43",
        title: "特别奖项",
        targetSelector: ".selection-pc__award--content.special",
        targetSelectorM: ".selection-m__award--content.special"
      }
    ]
  },
  {
    id: "5",
    title: "参评指引",
    targetSelector: ".selection-pc__guidance",
    targetSelectorM: ".selection-m__guidance"
  },
  {
    id: "6",
    title: "评分标准",
    targetSelector: ".selection-pc__standard",
    targetSelectorM: ".selection-m__standard"
  },
  {
    id: "7",
    title: "参评权益",
    targetSelector: ".selection-pc__benefit",
    targetSelectorM: ".selection-m__benefit"
  },
  {
    id: "8",
    title: "常见问题",
    targetSelector: ".selection-pc__question",
    targetSelectorM: ".selection-m__question"
  },
  {
    id: "9",
    title: "往期回顾",
    targetSelector: ".selection-pc__review",
    targetSelectorM: ".selection-m__review"
  },
  {
    id: "10",
    title: "主办方",
    targetSelector: ".summit-organizer__list",
    targetSelectorM: ".selection-m__organizer"
  },
  {
    id: "11",
    title: "联系我们",
    targetSelector: ".selection-pc__contact",
    targetSelectorM: ".selection-m__organizer"
  }
];

// 参评指引
export const GUIDANCE_URL =
  "https://image.roadshowchina.cn/pdf/index.php?key=L1VwbG9hZHMvQWN0aXZpdHkvdm90ZS8yMDI1LyVFMyU4MCU5MCVFNSU4RiU4MiVFOCVBRiU4NCVFNiU4QyU4NyVFNSVCQyU5NSVFMyU4MCU5MSVFNyVBQyVBQyVFNSU4NSVBQiVFNSVCMSU4QSVFNCVCOCVBRCVFNSU5QiVCRCVFNSU4RCU5MyVFOCVCNiU4QUlSJUU4JUFGJTg0JUU5JTgwJTg5LnBkZg==";
// 报名投资者关系峰会（PC）
export const IR_URL =
  "https://vote.roadshowchina.cn/activity/20221029/#/sixth/activityPc";
// 报名投资者关系峰会（H5）
export const IR_URL_M =
  "https://vote.roadshowchina.cn/activity/20221029/#/sixth/activityPc";



// WEBPACK FOOTER //
// ./src/page/eighth/common/constant.js